export const ADMIN = 'ADMIN';
export const AGENT = 'AGENT';
export const VENDOR = 'VENDEUR';
